import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filteredCruisePackagesCountSelector } from '../../redux/selectors/cruiseList/filterSelectors';
import './cruiseListHits.scss';

const CruiseListHits = ({
  labels,
  numberOfCruises,
  numberOfFilteredCruises,
}) => {
  const getNumberOfCruisesLabel = () => {
    let numberOfCruisesLabel = '';

    if (numberOfFilteredCruises === numberOfCruises) {
      numberOfCruisesLabel = labels.cruiseCountLabel.replace(
        '{numberOfCruises}',
        numberOfCruises,
      );
    } else {
      numberOfCruisesLabel = labels.filteredCruiseCountLabel
        .replace('{matches}', numberOfFilteredCruises)
        .replace('{total}', numberOfCruises);
    }

    return numberOfCruisesLabel;
  };

  return <div className="iw-cruise-list-hits">{getNumberOfCruisesLabel()}</div>;
};

CruiseListHits.propTypes = {
  labels: PropTypes.shape({
    filterHeading: PropTypes.string.isRequired,
    cruiseCountLabel: PropTypes.string.isRequired,
    filteredCruiseCountLabel: PropTypes.string.isRequired,
  }).isRequired,
  numberOfCruises: PropTypes.number.isRequired,
  numberOfFilteredCruises: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const newState = state.toJS();
  const numberOfCruises = newState.cruises.cruises.length;

  return {
    labels: newState.labels,
    numberOfCruises,
    numberOfFilteredCruises: filteredCruisePackagesCountSelector(newState),
  };
}

export default connect(mapStateToProps)(CruiseListHits);
